var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeWidth: 1.125,
    d: "M8.551 4.15v9.681"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.125,
    d: "M4.388 2.272c2.311.44 3.688 1.36 4.163 1.889.475-.529 1.852-1.449 4.163-1.889 1.17-.223 1.756-.334 2.254.093.499.427.499 1.12.499 2.508v4.985c0 1.269 0 1.903-.32 2.299-.32.396-1.024.53-2.433.798-1.256.24-2.236.62-2.945 1.003-.698.377-1.047.565-1.218.565-.17 0-.52-.188-1.217-.565-.71-.383-1.69-.764-2.946-1.003-1.408-.268-2.113-.402-2.432-.798-.32-.396-.32-1.03-.32-2.299V4.873c0-1.387 0-2.081.498-2.508.499-.427 1.084-.316 2.254-.093Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svgFill",
    d: "M0 0h16.597v16.597H0z",
    transform: "translate(.253)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/book-open.a3d50da5.svg";
export { ForwardRef as ReactComponent };